<app-navbar *ngIf="toggleNavSVC.visible"></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="toggleNavSVC.visible"></app-footer>

<!-- Contenedor flotante de botones -->
<div class="fab-container" [class.is-visible]="showFloatingButtons">

  <a href="https://api.whatsapp.com/send?phone=5493454055364&text=Consulta%20desde%20www.establecimientolangelica.com.ar"
    target="_blank" class="fab-btn fab-wsp">
    <img src="assets/icons/wsp.svg" alt="WhatsApp">
  </a>

  <a routerLink="/reservas" class="fab-btn fab-reservas">
    <img src="assets/icons/calendar.svg" alt="Reservas">
  </a>

</div>
